export function validateJSON(str: string | undefined): boolean {
  if (!str) return false
  try {
    JSON.parse(str)
    return true
  } catch {
    return false
  }
}
